<template>
  <div class="credit">
    <h3>{{$t('title.w35')}}</h3>
    <table>
      <thead>
        <tr>
          <th>{{$t('label.w61')}}</th>
          <th>{{$t('label.w104')}}</th>
          <th>{{$t('label.w105')}}</th>
          <th>{{$t('label.w106')}}</th>
        </tr>
      </thead>
      <tbody style="height:240px" v-if="data&&data.length">
        <tr>
          <td>{{$t('label.w107')}}</td>
          <td class="warn">{{data[0].HalfYear}}</td>
          <td class="warn">{{data[0].OneYear}}</td>
          <td class="warn">{{data[0].Total}}</td>
        </tr>
        <tr>
          <td>{{$t('label.w108')}}</td>
          <td class="blue">{{data[1].HalfYear}}</td>
          <td class="blue">{{data[1].OneYear}}</td>
          <td class="blue">{{data[1].Total}}</td>
        </tr>
        <tr>
          <td>{{$t('label.w109')}}</td>
          <td>{{data[2].HalfYear}}</td>
          <td>{{data[2].OneYear}}</td>
          <td>{{data[2].Total}}</td>
        </tr>
        <tr>
          <td>{{$t('label.w110')}}</td>
          <td>{{data[3].HalfYear}}</td>
          <td>{{data[3].OneYear}}</td>
          <td>{{data[3].Total}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["data"]
};
</script>


<style lang="less" scoped>
.credit {
  background: #fff;
  padding: 0 25px;
  .warn {
    color: #ff8b8b;
  }
  .blue {
    color: #6c95ee;
  }
  h3 {
    height: 60px;
    background: #fff;
    line-height: 60px;
    padding-left: 30px;
    font-size: 16px;
    color: #333333;
    border-top: 1px solid #f0f1f9;
  }
  table tbody {
    display: block;
    height: 360px;
    // overflow-y: auto;
    border-radius: 8px;
  }
  table thead tr {
    padding-right: 15px;
  }
  table thead,
  tbody tr {
    display: table;
    width: 100%;
    height: 60px;
    table-layout: fixed;
    border-bottom: 1px solid #f0f1f9;
  }

  table thead {
    //   width: calc( 100% - 1em );
    height: 38px;
  }
  table tbody td {
    padding: 10px 15px;
    text-align: center;
    height: 60px;
    font-size: 14px;
    color: #333333;
    &:first-child {
      text-align: left;
      padding-left: 30px;
    }
  }
  // tr:last-child {
  //   // border-bottom: 0;
  // }
  table thead th {
    padding: 10px 15px;
    height: 38px;
    font-size: 14px;
    background: rgb(53, 110, 236);
    opacity: 0.7;
    text-align: center;
    color: #fff;
    &:first-child {
      text-align: left;
      padding-left: 30px;
    }
  }
}
</style>

